import React from 'react';
import { Divider } from '@mui/material';

import ThemeButtons from '../../../components/theme/ThemeButtons';
import LanguagesSwitch from './LanguagesSwitch';

import scss from './SupportSection.module.scss';

function SupportSection() {
  return (
    <div>
      <Divider />

      <div className={scss.wrapper}>
        <LanguagesSwitch />

        <ThemeButtons />
      </div>
    </div>
  );
}

export default SupportSection;
